export default __webpack_public_path__ + "static/media/Flag_of_Bermuda.50881167.svg";